import { render, staticRenderFns } from "./VersionFwList.vue?vue&type=template&id=01d16df9&scoped=true"
import script from "./VersionFwList.vue?vue&type=script&lang=js"
export * from "./VersionFwList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d16df9",
  null
  
)

export default component.exports